export default function () {
  return {
    accessToken: null
  }
}
